import { useContentful } from '@pcln/contentful-components'
import { useFeature } from '@pcln/feature-components'
import useContent from './useContent'

export default function useContentfulSearchFormHeadlines(
  name: string,
  shouldFireImpression = true
) {
  const searchFormResponse: any = useContentful(name)
  const searchForm = useContent(searchFormResponse, shouldFireImpression)
  const contentfulEnabled = useFeature('siteExperience.contentfulEnabled', true)
  const contentfulEnabledAndHasContent = contentfulEnabled && searchForm != null

  return contentfulEnabledAndHasContent ? searchForm : null
}
